import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PricingService {

  constructor(private _http: HttpClient) { }

  getData(): Observable<any> {
    return this._http
      .get(`${environment.apiUrl}get-plan-dropdown`)
      .pipe(
        map(data => {
          return data;
        })
      );
  }

}
